import { render } from "./ContractRecords.vue?vue&type=template&id=498916f1&scoped=true"
import script from "./ContractRecords.vue?vue&type=script&lang=js"
export * from "./ContractRecords.vue?vue&type=script&lang=js"

import "./ContractRecords.vue?vue&type=style&index=0&id=498916f1&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498916f1"]])

export default __exports__